<div class="form-dialog component-form-tile">
  @for (msg of missingPermissions; track $index) {
    <div class="row auto warning info">
        {{ msg }}
    </div>
  }
  @if (component?.id && !config.component) {
    <div class="row warning info">
      You are now editing an EXISTING {{name}}. Click 'Apply changes' to edit or 'Clear' to add a new {{name}}.
    </div>
  }
  <div class="row min-height justify-end">
    <label class="required-info" [ngClass]="{'existing':component?.id && !config.component}">* Required fields</label>
  </div>
  @if (component && dtp) {
    <div class="row auto attributes-container">
      <mat-form-field class="component-form-name" style="margin:0;">
        <mat-label class="label-required">{{name_column?.title || name_column?.column_name || 'Name'}}
          <span style="font-weight: normal;">{{autoName ? ' (This field will auto-populate)' : ''}}</span>
        </mat-label>
        <input [ngModel]="autoName ? nameFormulaString : component.attributes.name"
          (ngModelChange)="autoName ? nameFormulaString : component.attributes.name = $event"
          [disabled]="(component.id && name_column?.disabled) || generic_field_dict?.name?.locked || !canSaveComponent || autoName"
          matInput name="name"
          placeholder="">
      </mat-form-field>
      @if (start_column) {
        <div class="component-form-time">
          <mat-label [ngClass]="{'label-required':start_column.required}">Start time</mat-label>
          @if (dtp) {
            <date-time-picker
              (date_changed)="component.attributes.start_time = $event;revalidateField($event, start_column)"
              [default]="dtp.start"
              [input_date]="component?.attributes.start_time"
              [set_default]="false"
              [disabled]="(start_column.disabled && !!component.id) || generic_field_dict?.start_time?.locked || !canSaveComponent"
              [ngClass]="{'missing-required':missing.start_time}"
            ></date-time-picker>
          }
        </div>
      }
      @if (end_column) {
        <div class="component-form-time">
          <mat-label [ngClass]="{'label-required':end_column.required}">End time</mat-label>
          <date-time-picker
            (date_changed)="component.attributes.end_time = $event;revalidateField($event, end_column)"
            [default]="dtp.end"
            [input_date]="component?.attributes.end_time"
            [set_default]="false"
            [disabled]="(end_column.disabled && !!component.id) || generic_field_dict?.end_time?.locked || !canSaveComponent"
            [ngClass]="{'missing-required':missing.end_time}"
          ></date-time-picker>
        </div>
      }
    </div>
  }

  @if (constant_properties && custom_constant_dict !== undefined && dtp) {
    <div class="component-constants">
      @if (config.group_columns && editable_cols?.length) {
        <div (click)="show_editable=!show_editable"
          class="column-group">
          <div>Editable columns
            <span class="material-symbols-outlined arrow" matTooltip="Expand row">
            {{show_editable ? 'arrow_drop_down' : 'arrow_right'}}</span></div>
          </div>
        }
        @if (!config.group_columns || show_editable) {
          @for (prop of editable_cols; track prop) {
            @if (prop.type==='constant_property') {
              <ng-container [ngTemplateOutlet]="constantElement"
              [ngTemplateOutletContext]="{ $implicit: prop, disabled_col: false}"></ng-container>
            }
            @if (prop.type==='component_type') {
              <ng-container [ngTemplateOutlet]="componentElement"
              [ngTemplateOutletContext]="{ $implicit: prop, disabled_col: false}"></ng-container>
            }
          }
        }
        @if (config.group_columns && disabled_cols?.length) {
          <div (click)="show_disabled=!show_disabled"
            class="column-group">
            <div>Non-editable columns
              <span class="material-symbols-outlined arrow" matTooltip="Expand row">
              {{show_disabled ? 'arrow_drop_down' : 'arrow_right'}}</span></div>
            </div>
          }
          @if (!config.group_columns || show_disabled) {
            @for (prop of disabled_cols; track prop) {
              @if (prop.type==='constant_property') {
                <ng-container [ngTemplateOutlet]="constantElement"
                [ngTemplateOutletContext]="{ $implicit: prop, disabled_col: true}"></ng-container>
              }
              @if (prop.type==='component_type') {
                <ng-container [ngTemplateOutlet]="componentElement"
                [ngTemplateOutletContext]="{ $implicit: prop, disabled_col: true}"></ng-container>
              }
            }
          }
          <ng-template #constantElement let-prop let-disabled_col="disabled_col">
            @if (custom_constant_dict.hasOwnProperty(prop.id) && prop_ids.includes(prop.id)) {
              <div class="constant-input-element"
                [ngClass]="{'missing-required':missing[prop.id]}"
                >
                <label
                  [ngClass]="{'label-required':prop.required && !cpDict[prop.id].attributes.is_calculation}">
                {{prop.title || prop.column_name || cpDict[prop.id]?.attributes.name | removeUnderscore | upperfirst}}</label>
                <generic-component-field
                  [constant_property]="cpDict[prop.id]"
                  [constant]="generic_field_dict[prop.id]"
                  [component]="component"
                  (relayConstantChangedEmitter)="custom_constant_dict[prop.id] = $event;revalidateField($event, prop)"
                  (relayChangeCompleteEmitter)="changeComplete($event, prop.id)"
                  [disabled]="!canEditConstantField(prop.id) || disabled_col"
                  [show_sig]="false"
                  [defaultValue]="prop.default_value"
                ></generic-component-field>
              </div>
            }
          </ng-template>
          <ng-template #componentElement let-column let-disabled_col="disabled_col">
            <!--Component Types-->
            @if (ctCtDict[column.id]?.isUnique) {
              <select-search-component
                (selectionChange)="updateComponentComponentRelationship(column.id, $event);"
                [disabled]="!canEditLinkField() || disabled_col"
                [label]="column.title || column.column_name"
                [required]="column.required"
                [component_types]=[column.id]
                [api_model]="'component'"
                [compareFunctionName]="'compareById'"
                [custom_filters]="componentComponentTypeMap.filters?.[column.id]"
                [allow_none]="true"
                [sort_by]="'-created_on'"
                [classes]="'full-width min-max-inherit show-select-arrow'"
                [ngClass]="{'missing-required':missing?.[column.id]}"
                [value]="!!component?.id? componentComponentDict?.[column.id]?.[0]:originalSelectedComponentDict?.[column.id]">
              </select-search-component>
            }
            @if (ctCtDict[column.id] && !ctCtDict[column.id].isUnique) {
              <select-many-search-component
                (selectionChangeComplete)="updateComponentComponentRelationship(column.id, $event);"
                [disabled]="!canEditLinkField() || disabled_col"
                [required]="column.required"
                [label]="column.title || column.column_name"
                [api_model]="'component'"
                [custom_filters]="componentComponentTypeMap.filters?.[column.id]"
                [custom_selected_filters]="componentComponentTypeMap.selectedFilters?.[column.id]"
                [compareFunctionName]="'compareById'"
                [sort_by]="'-created_on'"
                [classes]="'auto-width min-max-inherit'"
                [ngClass]="{'missing-required':missing?.[column.id]}"
                [value]="(!!component?.id? componentComponentDict?.[column.id]:originalSelectedComponentDict?.[column.id]) || []"
                >
              </select-many-search-component>
            }
          </ng-template>
        </div>
      }

      @if (!component?.id) {
        <button (click)="save()"
          [ngClass]="{'disabled': isSaveBlocked() || (!component?.attributes?.name && !isNameComplete())}"
          [disabled]="isSaveBlocked() || (!component?.attributes?.name && !isNameComplete())"
          [style.cursor]="(!isSaveBlocked() && ((component?.attributes?.name && !component?.id) || isNameComplete()))? 'pointer': 'not-allowed'"
          class="big-btn save"
          mat-raised-button
          style="width:220px;">Save
        </button>
      }
      @if (component?.id) {
        <button (click)="save()"
          [ngClass]="{'disabled': isSaveBlocked() || !component?.attributes?.name}"
          [disabled]="isSaveBlocked() || !component?.attributes?.name"
          [style.cursor]="(!isSaveBlocked() && component?.attributes?.name && component?.id)? 'pointer': 'not-allowed'"
          [matTooltip]="'Apply changes to the existing ' + name"
          class="big-btn save"
          mat-raised-button
          style="align-self: center;margin-bottom: 14px;height: 40px;width:220px;">Apply changes
        </button>
      }
      @if (!config.component) {
        <button (click)="clearForm()"
          class="big-btn clear"
          mat-stroked-button
          >Clear
        </button>
      }

    </div>
